import { ActionBar, ButtonVariant, usePush } from '@dreryk/react-components';

import { patientPaths } from '~libs.desktop.shared.paths';

import { patientTranslationKeys } from '../translations';

const AddPatientAction = (): JSX.Element => {
   const push = usePush();

   const goToAddPatient = (): void => {
      push(patientPaths.getCreateFormPath());
   };

   return (
      <ActionBar.PrimaryButton
         testId='addPatient'
         label={patientTranslationKeys.addPatientButton}
         onClick={goToAddPatient}
         variant={ButtonVariant.PRIMARY}
      />
   );
};

export { AddPatientAction };
